<div #chartContainer style="width: 100%; height: 300px"></div>
